<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    location="bottom"
    min-width="290px"
  >
    <template v-slot:activator="{ props }">
      <v-text-field
        :model-value="formattedDate"
        :label="label"
        :rules="rules"
        v-bind="props"
        prepend-icon="mdi-calendar"
        readonly
        variant="outlined"
        density="compact"
      ></v-text-field>
    </template>

    <v-locale-provider :locale="language">
      <v-date-picker
        ref="picker"
        v-model="selectedDate"
        :min="minDate"
        :max="maxDate"
        view-mode="year"
      ></v-date-picker>
    </v-locale-provider>
  </v-menu>
</template>

<script>
export default {
  props: {
    modelValue: Date,
    label: String,
    rules: Array,
    minDate: {
      type: String,
      default: new Date("1957-01-01").toISOString(),
    },
    maxDate: {
      type: String,
    },
  },

  data: () => ({
    menu: false,
  }),

  // emits: ["update:modelValue"],

  computed: {
    language() {
      return this.$root.$i18n.locale;
    },
    formattedDate() {
      if (
        this.modelValue &&
        this.$dayjs(this.modelValue).format("YYYY-MM-DD") !== "1970-01-01"
      ) {
        if (this.language === "en")
          return this.$dayjs(this.modelValue, "YYYY-MM-DD")
            .locale("en")
            .format("D MMMM YYYY");
        else if (this.language === "th")
          return this.$dayjs(this.modelValue, "YYYY-MM-DD")
            .locale("th")
            .format("D MMMM BBBB");
      }
      return "";
    },
    selectedDate: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
        this.menu = false;
      },
    },
  },

  created() {
    if (this.modelValue === null)
      this.$emit("update:modelValue", new Date("1970-01-01"));
  },
};
</script>
